function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
// TODO: Move string mapping to appropriate mapper
export var LockType = /*#__PURE__*/function (LockType) {
  LockType["None"] = "None";
  LockType["Read"] = "Read";
  LockType["Edit"] = "Edit";
  return LockType;
}({});

// TODO: Deprecate 'UNKNOWN' in favor of throwing error if unknown
// TODO: Move string mapping to appropriate mapper
export var LockLevel = /*#__PURE__*/function (LockLevel) {
  LockLevel["Ancestor"] = "ANCESTOR";
  LockLevel["Descendant"] = "DESCENDANT";
  LockLevel["Master"] = "MASTER";
  LockLevel["UNKNOWN"] = "UNKNOWN";
  return LockLevel;
}({});
export var LockContext = /*#__PURE__*/function (LockContext) {
  LockContext["Approvals"] = "Approvals";
  LockContext["Esign"] = "Esign Approvals";
  return LockContext;
}({});
var ItemLock = /*#__PURE__*/_createClass(/* eslint-disable-next-line max-params */
function ItemLock(type, level, permissions, createdBy, createdDate, contextInfo, context) {
  _classCallCheck(this, ItemLock);
  this.type = type;
  this.level = level;
  this.permissions = permissions;
  this.createdBy = createdBy;
  this.createdDate = createdDate;
  this.contextInfo = contextInfo;
  this.context = context;
  // I don't like redundant data, but this is a frequent check.
  this.isMaster = void 0;
  this.isMaster = level === LockLevel.Master;
});
export { ItemLock as default };
